import PropTypes from 'prop-types';

export default class InWishlistSummary extends React.Component {
  static propTypes = {
    foundWishlists: PropTypes.array
  };
  static defaultProps = {
    foundWishlists: []
  };
  constructor() {
    super();

    this.state = {
      active: false
    };
  }
  _onClickNavHandler = () => {
    this.setState({ active: !this.state.active });
  };
  _renderFoundWishlist = (wishlist) => {
    return (
      <li className="row" key={wishlist.wishListId}>
        <span className="xs-6 lg-8 wishlist-found pr txt-left">
          {`${wishlist.quantity} ITEM${(wishlist.quantity > 1) ? 'S' : ''} IN ${wishlist.wishListName}`}
        </span>
        <a href={`/weddings/ideas/wishlist/?wishListId=${wishlist.wishListId}`} className="xs-6 lg-4 wishlist-anchor">
          <i className="icon-arrow-right"/> VIEW WISHLIST
        </a>
      </li>
    );
  };
  render() {
    const totalItems = this.props.foundWishlists.map((el) => el.quantity ).reduce((total, quantity) => quantity + total, 0);
    const resultsMsg = `${totalItems} ITEMS IN ${this.props.foundWishlists.length} WISHLIST${(this.props.foundWishlists.length > 1) ? 'S' : ''}`;

    return (
      <nav className={`in-wishlist-summary txt-center ${this.state.active}`}>
        <span className="summary-ttl display-block" onClick={ this._onClickNavHandler }><i className="icon-arrow-right"/>{resultsMsg}</span>
        <ul className="wishlists">
          {
            this.props.foundWishlists.map((wishlist) => this._renderFoundWishlist(wishlist) )
          }
        </ul>
      </nav>
    );
  }
}
